export default __webpack_public_path__ + "static/media/imgPrize3.7bf28b9e.png";